// test1842
(1842 && 0);
